import { fetchBackendJson, hasBackendApiConfig } from '../lib/backendApi';
import { bagFromCmsSections, enabledSections } from './cmsTypes';

export const fetchPublicHomepageSections = async () => {
  if (!hasBackendApiConfig) return null;
  try {
    const payload = await fetchBackendJson('/cms/homepage');
    const sections = Array.isArray(payload?.sections) ? payload.sections : [];
    return enabledSections(sections);
  } catch {
    return null;
  }
};

export const fetchPublicAboutSections = async () => {
  if (!hasBackendApiConfig) return null;
  try {
    const payload = await fetchBackendJson('/cms/about');
    const sections = Array.isArray(payload?.sections) ? payload.sections : [];
    return enabledSections(sections);
  } catch {
    return null;
  }
};

export const fetchPublicSiteSettings = async () => {
  if (!hasBackendApiConfig) return null;
  try {
    return await fetchBackendJson('/cms/site-settings');
  } catch {
    return null;
  }
};

export const fetchPublicCmsPageBySlug = async (slug) => {
  if (!hasBackendApiConfig || !slug) return null;
  try {
    return await fetchBackendJson(`/cms/pages/${encodeURIComponent(slug)}`);
  } catch {
    return null;
  }
};

export const fetchCmsPageBag = async (slug) => {
  const page = await fetchPublicCmsPageBySlug(slug);
  if (!page?.sections?.length) return null;
  return bagFromCmsSections(slug, page.sections);
};

/** Build fallback homepage sections from ContentContext bags. */
export const legacyHomeSectionsFromContent = (content = {}) => {
  const home = content.homeContent || {};
  const services = content.servicesContent || {};
  const ventures = content.venturesContent || {};
  return [
    { id: 'legacy-hero', type: 'hero', enabled: true, sortOrder: 0, content: home.hero || {} },
    { id: 'legacy-about', type: 'aboutBio', enabled: true, sortOrder: 1, content: home.about || {} },
    { id: 'legacy-services', type: 'services', enabled: true, sortOrder: 2, content: services },
    { id: 'legacy-ventures', type: 'ventures', enabled: true, sortOrder: 3, content: ventures },
    {
      id: 'legacy-testimonials',
      type: 'testimonials',
      enabled: true,
      sortOrder: 4,
      content: home.testimonials || {},
    },
  ];
};

export const legacyAboutSectionsFromContent = (content = {}) => {
  const about = content.aboutContent || {};
  return [
    { id: 'legacy-about-hero', type: 'hero', enabled: true, sortOrder: 0, content: about.hero || {} },
    { id: 'legacy-about-tabs', type: 'tabs', enabled: true, sortOrder: 1, content: { tabs: about.tabs || [] } },
  ];
};
